<template>
  <div class="sorting-arrow">
    <slot></slot>
    <p v-if="value.dir && value.dir == 'asc'" v-on:click="dir"><icon icon="arrow-up"></icon></p>
    <p v-on:click="dir" v-else><icon icon="arrow-down"></icon></p>
  </div>
</template>

<script>

export default {
  name: 'SortingColumn',
  props: ['value', 'field'],
  methods:
  {
    dir()
    {
      var me = this;

      me.$set(me.value, 'sort', me.field);

      if(me.value.dir == undefined)
      {
        me.$set(me.value, 'dir', 'asc');
      }
      else
      {
        var dir = 'asc';
        if(me.value.dir == 'asc') dir = 'desc';
        me.$set(me.value, 'dir', dir);
      }

      this.$emit('input', me.value);
      this.$emit('reload');
    }
  }
}
</script>
